import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// Legacy URL — permanently redirect to the Brian Urlacher results page.
export const Route = createFileRoute("/blog/tag/brian-urlacher")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/results/brian-urlacher/", location.searchStr), statusCode: 301 });
  },
});
